<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="isCreate ? newRules : updateRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>

            <!-- <div class="flex">
              <base-ro-input-minimal :label="$t('app.enuso_extend')"/>
            </div> -->

            <div class="lg:mb-2" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div class="flex justify-between items-center">
                <div class="flex-1">
                  <AccessibleElSelect
                    v-model="form.clienteId"
                    prop="clienteId"
                    :options="clientesForAccessibleSelect"
                    :isDisabled="!isCreate"
                    id-prefix="rule"
                  >
                    <template slot="label">
                      <base-obligatory-icon v-if="isCreate"/>
                      {{$t('app.client')}}
                    </template>
                  </AccessibleElSelect>
                </div>
                <base-button
                  v-if="!isCreate"
                  class="ml-4"
                  mode="primary"
                  :text="$t('app.detail')"
                  @click.prevent.stop="goDetailClient"
                  :loading="isGeneralLoading"
                  :disabled="isGeneralLoading"
                />
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('configurations.name')}}
                  <el-form-item prop="name">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.name"
                      maxlength='100'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            
            <div class="lg:mb-2">
                <div class="mandatory">
                  <div class="flex items-center mb-1">
                    <label class="text-sm font-semibold text-secondary-600 block">{{$t('configurations.prioridad')}}</label>
                    <base-tooltip-icon size="sm" :content="tooltipPrioridad" class="ml-2"/>
                  </div>
                  <el-form-item prop="prioridad">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.prioridad"
                      maxlength='5'
                    />
                  </el-form-item>
                </div>
            </div>

            <div class="mb-6">
              <AccessibleElSelect
                v-model="form.MomentoAplicacion"
                prop="MomentoAplicacion"
                :options="valuesForMomentoAplicacionReglasForAccessibleSelect"
                :withFormItem="true"
                id-prefix="ruleMomentoAplicacion"
              >
                <template slot="label">{{$t('rules.tipo_app')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="mb-4" v-if="form.MomentoAplicacion === 1 || form.MomentoAplicacion === 3">
              <label for="switch-descargar-automaticamente" class="sr-only">
                {{$t('companies.group_download')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.group_download')}}
              </label>
              <div class="flex flex-row items-center">
                <el-switch 
                  id="switch-descargar-automaticamente"
                  :aria-label="$t('companies.group_download')"
                  class="switch-text break-normal" 
                  v-model="form.DescargarAutomaticamente" 
                  :active-text="$t('companies.group_download')"></el-switch>
                <base-tooltip-icon size="sm" :content="$t('tooltip.rules.auto_download')" class="ml-2"/>
              </div>
            </div>

            <div class="mb-4">
              <label for="switch-detener-ejecucion" class="sr-only">
                {{$t('groups.detener_ejecucion')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('groups.detener_ejecucion')}}
              </label>
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <el-switch 
                  id="switch-detener-ejecucion"
                  :aria-label="$t('groups.detener_ejecucion')"
                  class="switch-text break-normal" 
                  v-model="form.DetenerEjecucion" 
                  :active-text="$t('groups.detener_ejecucion')"></el-switch>
              </div>
            </div>

            <div class="mb-4" v-if="hasModuleAsistenciaIA && (form.MomentoAplicacion === 2 || form.MomentoAplicacion === 3)">
              <label for="switch-asistencia-ia" class="sr-only">
                {{$t('rules.asistencia_ia')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('rules.asistencia_ia')}}
              </label>
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <el-switch 
                  id="switch-asistencia-ia"
                  :aria-label="$t('rules.asistencia_ia')"
                  class="switch-text break-normal" 
                  v-model="form.EnviarIA" 
                  :active-text="$t('rules.asistencia_ia')"></el-switch>
                <base-tooltip-icon v-if="form.MomentoAplicacion === 3" size="sm" :content="$t('tooltip.rules.asistencia_ia')" class="ml-2"/>
              </div>
            </div>

            <div class="mb-4">
              <label for="switch-activa" class="sr-only">
                {{$t('configurations.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.active')}}
              </label>
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <el-switch 
                  id="switch-activa"
                  :aria-label="$t('configurations.active')"
                  class="switch-text break-normal" 
                  v-model="form.Activa" 
                  :active-text="$t('configurations.active')"></el-switch>
              </div>
            </div>

            <div class="lg:mb-2" v-if="form.MomentoAplicacion !== 3 && (!form.DescargarAutomaticamente || form.MomentoAplicacion === 2)">
              <AccessibleElSelect
                v-model="form.estadoDestino"
                prop="estadoDestino"
                :options="tiposEstadoDescargaForAccessibleSelect"
                id-prefix="rule"
              >
                <template slot="label">{{$t('app.estado_destino')}}</template>
              </AccessibleElSelect>
            </div>

            <div v-if="(role !== 'AdminDistribuidor' && role !== 'SuperAdminDistribuidor' && role !== 'SuperAdministrador') || form.clienteId">

              <div class="flex flex-row items-center">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('rules.condiciones')}}</h2>
              </div>

              <div v-for="(condicion, key) in form.condiciones" :key="key"
                class="mb-2 mt-2 flex flex-col items-center w-full relative"
                >
                <div 
                  v-if="key > 0"
                  class="-top-5 absolute pl-2 pr-2 pt-1 pb-1 flex content-center justify-center dark:text-darkblue-200 bg-primary-50 dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border"
                  >
                  AND
                </div>
                <base-button-icon
                  @click="removeCondiction(key)"
                  ariaLabel="Eliminar condición"
                  name="cross"
                  mode="primary-phantom"
                  class="-top-3 -right-3 absolute"
                  custom="dark:border dark:border-darkblue-600"
                />
                <div class="w-full p-4 bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border">
                  <div class="flex -mx-2 flex-col lg:flex-row">
                    <div class="px-2 w-full lg:mb-0">
                      <div class="flex items-center mb-1">
                        <label class="text-sm font-semibold text-secondary-600 block">{{$t('rules.campo')}}</label>
                        <base-tooltip-icon 
                          size="sm" 
                          :content="contentTooltipMetadatos" 
                          class="ml-2"/>
                      </div>
                        <el-form-item :prop="'condiciones.'+ key + '.campo'"
                          :rules="generalRules.general"
                          >
                          <AccessibleElSelect
                            :withFormItem="false"
                            v-model="form.condiciones[key].campo"
                            :prop="'condiciones.' + key + '.campo'"
                            :options="dataMetadatosCondicionesForAccessibleSelect"
                            :group="true"
                            clearable
                            id-prefix="rule-condicion-campo"
                            @change="onChangeMetadato(key)"
                          />
                        </el-form-item>
                    </div>
                    <div class="px-2 w-full lg:mb-0">
                      <label class="text-sm font-semibold text-secondary-600 block mt-1">{{$t('rules.tipo_condicion')}}
                        <el-form-item :prop="'condiciones.'+ key + '.tipoCondicion'"
                          :rules="generalRules.general"
                          >
                          <AccessibleElSelect
                            :withFormItem="false"
                            v-model="form.condiciones[key].tipoCondicion"
                            :prop="'condiciones.' + key + '.tipoCondicion'"
                            :options="getListaCondicionesForAccessibleSelect(form.condiciones[key].campo)"
                            clearable
                            id-prefix="rule-condicion-tipo"
                            @change="onChangeTipoCondicion(key)"
                          />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                  <div class="flex -mx-2 flex-col lg:flex-row">
                    <div class="px-2 w-full lg:mb-0">
                      <div class="flex items-center mb-1">
                        <div class="flex items-center">
                          <label class="text-sm font-semibold text-secondary-600 block">{{$t('rules.valor')}}</label>
                          <base-tooltip-icon 
                            v-if="(form.condiciones[key].tipoCondicion === 9 || form.condiciones[key].tipoCondicion === 10)" 
                            size="sm" 
                            :content="contentTooltipValorRegex" 
                            class="ml-2"/>
                          <base-tooltip-icon 
                             v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                      (
                                        form.condiciones[key].campo === 'Organismo'
                                      ) &&
                                      (
                                        form.condiciones[key].tipoCondicion === 1 ||
                                        form.condiciones[key].tipoCondicion === 2
                                      )"
                            size="sm" 
                            :content="'Selecciona una agrupación o escribe para realizar una búsqueda'" 
                            class="ml-2"/>
                          <base-tooltip-icon 
                             v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                      (
                                        form.condiciones[key].campo === 'CIF Notificado' ||
                                        form.condiciones[key].campo === 'CIF Titular'
                                      ) &&
                                      (
                                        form.condiciones[key].tipoCondicion === 1 ||
                                        form.condiciones[key].tipoCondicion === 2
                                      )"
                            size="sm" 
                            :content="'Seleccione un CIF, una agrupación o escriba un valor y selecciónelo'" 
                            class="ml-2"/>
                          <base-tooltip-icon 
                            v-else-if="getTipoDato(form.condiciones[key].campo) === 2 && form.condiciones[key].tipoCondicion !== 2"
                            size="sm" 
                            :content="'Seleccione una agrupación de valores o escriba un valor y selecciónelo'" 
                            class="ml-2"/>
                        </div>
                      </div>

                          <div class="w-full">
                            <div v-for="(valor, keyValor) in condicion.valores" :key="keyValor"
                              class="relative flex w-full items-center justify-center"
                              >
                              <div 
                                v-if="keyValor > 0"
                                class="text-xs z-20 -top-5 absolute pl-1 pr-1 dark:text-darkblue-200 bg-primary-50 dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border"
                                >
                                OR
                              </div>
                                <div class="flex w-full">
                                  <el-form-item :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                    :rules="generalRules.general"
                                    class="w-full"
                                    >

                                    <AccessibleElSelect
                                      v-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                      (
                                        form.condiciones[key].campo === 'Estado de Notificación'
                                      )"
                                      :withFormItem="false"
                                      :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      :options="estadosNotificationForAccessibleSelect"
                                      clearable
                                      id-prefix="rule-estado-notif"
                                    />
                                    
                                    <el-input
                                      v-else-if="getTipoDato(form.condiciones[key].campo) === 1"
                                      class="w-full"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      clearable
                                      min="0"
                                      max="9999999999"
                                      type="number"
                                      placeholder="Valor numérico"
                                    />
                                    
                                    <el-date-picker
                                      :clearable="false"
                                      aria-label="Valor fecha"
                                      v-else-if="getTipoDato(form.condiciones[key].campo) === 3"
                                      class="bg-white dark:bg-darkblue-900 full-width-important"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      :picker-options="dateRangeOptions"
                                      type="datetime"
                                      format="dd-MM-yyyy HH:mm:ss"
                                      placeholder="dd-MM-aaaa HH:mm:ss"
                                      :ref="'datePickerFechaAltaD' + key + keyValor"
                                      @blur="onBlurDatePickerMixin('.datePickerFechaAltaD-popover' + key + keyValor)"
                                      @focus="onFocusDatePickerMixin('.datePickerFechaAltaD-popover' + key + keyValor)"
                                      @keydown.native="captureKeyNotChrome"
                                      :popper-class="'datePickerFechaAltaD-popover' + key + keyValor"
                                      >
                                    </el-date-picker>

                                    <AccessibleElSelect
                                      v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                      (
                                        form.condiciones[key].campo === 'Organismo'
                                      ) &&
                                      (
                                        form.condiciones[key].tipoCondicion === 1 ||
                                        form.condiciones[key].tipoCondicion === 2
                                      )"
                                      :withFormItem="false"
                                      :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      :options="getListaSelect(form.condiciones[key].campo, form.condiciones[key].tipoCondicion === 2)"
                                      :group="true"
                                      :remote="true"
                                      :remoteMethod="remoteOrganismos"
                                      :loading="loadingOrganismos"
                                      :valueKey="'id'"
                                      popperClass="wrap-select-popover"
                                      id-prefix="rule-organismo"
                                    />

                                    <AccessibleElSelect
                                      v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                      (
                                        form.condiciones[key].campo === 'Tipo de Notificación'
                                      )"
                                      :withFormItem="false"
                                      :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      :options="tiposNotificationForAccessibleSelect"
                                      clearable
                                      id-prefix="rule-tipo-notif"
                                    />

                                    <AccessibleElSelect
                                      v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                      (
                                        form.condiciones[key].campo === 'CIF Notificado' ||
                                        form.condiciones[key].campo === 'CIF Titular'
                                      ) &&
                                      (
                                        form.condiciones[key].tipoCondicion === 1 ||
                                        form.condiciones[key].tipoCondicion === 2
                                      )"
                                      :withFormItem="false"
                                      :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      :options="getListaSelect(form.condiciones[key].campo, form.condiciones[key].tipoCondicion === 2)"
                                      :group="true"
                                      clearable
                                      :allowCreate="true"
                                      :maxlength="'100'"
                                      :valueKey="'id'"
                                      id-prefix="rule-cif"
                                    />

                                    <AccessibleElSelect
                                      v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                      (
                                        form.condiciones[key].campo === 'Grupo Propietario' ||
                                        form.condiciones[key].campo === 'Grupo Propietario'
                                      ) &&
                                      (
                                        form.condiciones[key].tipoCondicion === 1 ||
                                        form.condiciones[key].tipoCondicion === 2
                                      )"
                                      :withFormItem="false"
                                      :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      :options="getListaSelect(form.condiciones[key].campo, form.condiciones[key].tipoCondicion === 2)"
                                      clearable
                                      :maxlength="'100'"
                                      :valueKey="'id'"
                                      id-prefix="rule-grupo-propietario"
                                    />

                                    <AccessibleElSelect
                                      v-else-if="getTipoDato(form.condiciones[key].campo) === 2 &&
                                      (
                                        form.condiciones[key].campo === 'Sede' 
                                      ) &&
                                      (
                                        form.condiciones[key].tipoCondicion === 1 ||
                                        form.condiciones[key].tipoCondicion === 2
                                      )"
                                      :withFormItem="false"
                                      :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      :options="getListaSelect(form.condiciones[key].campo, form.condiciones[key].tipoCondicion === 2)"
                                      :group="true"
                                      clearable
                                      :valueKey="'id'"
                                      id-prefix="rule-sede"
                                    />

                                    <AccessibleElSelect
                                      v-else-if="getTipoDato(form.condiciones[key].campo) === 2 && form.condiciones[key].tipoCondicion !== 2"
                                      :withFormItem="false"
                                      :prop="'condiciones.'+ key + '.valores.' + keyValor"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      :options="getListaSelect ('Valores texto', false)"
                                      :group="true"
                                      clearable
                                      :allowCreate="true"
                                      :maxlength="'100'"
                                      :valueKey="'id'"
                                      id-prefix="rule-valores-texto"
                                    />

                                    <el-input
                                      v-else
                                      class="w-full"
                                      v-model="form.condiciones[key].valores[keyValor]"
                                      clearable
                                      maxlength='500'
                                      :placeholder="(form.condiciones[key].tipoCondicion === 9 || form.condiciones[key].tipoCondicion === 10) 
                                        ? 'Expresión regular'
                                        : 'Nuevo valor'"
                                    />

                                  </el-form-item>
                                  <div class="w-10">
                                    <base-button-icon
                                      v-if="form.condiciones[key].valores && form.condiciones[key].valores.length > 1"
                                      @click="removeValue(key, keyValor)"
                                      ariaLabel="Eliminar valor"
                                      name="cross"
                                      mode="primary-phantom"
                                      size="xs"
                                      iconSize="xs"
                                      class="ml-2 mt-1"
                                      custom="dark:border dark:border-darkblue-600"
                                      />
                                  </div>
                                </div>
                              </div>

                            <!-- Sin "OR" en caso de que sea el tipo de condicion "Distinto de" -->
                            <div 
                              v-if="form.condiciones[key].tipoCondicion !== 2"
                              class="flex flex-row items-center mt-2">
                              <base-button-responsive
                                mode="primary-phantom"
                                :text="$t('app.add_value')"
                                icon="plus"
                                @click="addValue(key)"
                                :loading="isGeneralLoading"
                                :disabled="isGeneralLoading"
                                custom="dark:border dark:border-darkblue-600"
                              />
                            </div>
                          </div>

                          <div
                            v-if="(form.condiciones[key].tipoCondicion === 9)" 
                          >
                            <div class="flex items-center mt-4 mb-1">
                              <label class="text-sm font-semibold text-secondary-600 block">{{$t('rules.metadata_regex')}}</label>
                              <base-tooltip-icon 
                                size="sm" 
                                :content="contentTooltipMetadataRegex" 
                                class="ml-2"/>
                            </div>
                            <el-form-item :prop="'condiciones.'+ key + '.metadatoRegex'"
                              :rules="generalRules.generalOptional"
                              class="w-full"
                              >
                              <AccessibleElSelect
                                :withFormItem="false"
                                :prop="'condiciones.'+ key + '.metadatoRegex'"
                                v-model="form.condiciones[key].metadatoRegex"
                                :options="listMetadatasClientForAccessibleSelect"
                                clearable
                                :allowCreate="true"
                                :maxlength="'100'"
                                id-prefix="rule-metadato-regex"
                              />

                              <!-- <el-input
                                class="w-full"
                                v-model="form.condiciones[key].metadatoRegex"
                                clearable
                                maxlength='100'
                              /> -->
                            </el-form-item>
                          </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="flex flex-row items-center">
                <base-button-responsive
                  mode="primary-phantom"
                  :text="$t('app.add_condition')"
                  icon="plus"
                  @click="addCondition()"
                  :loading="isGeneralLoading"
                  :disabled="isGeneralLoading"
                />
              </div>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="isCreate"
            mode="primary"
            :text="$t('app.save_and_continue')"
            icon="savearrow"
            @click="submitForm('ruleForm', true)"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { i18n } from '@/i18n'

import { TIPOS_NEO } from '@/config/tipos-neo'

import { getClients } from '@/services/clients/getClients'

import { getRule } from '@/services/configurations/rules/getRule'
import { newRule } from '@/services/configurations/rules/newRule'
import { updateRule } from '@/services/configurations/rules/updateRule'

import { getMetadatosCondiciones } from '@/services/configurations/rules/getMetadatosCondiciones'

import { getValoresTextoAgrupaciones } from '@/services/configurations/rules/getValoresTextoAgrupaciones'
import { getCifsAgrupaciones } from '@/services/configurations/rules/getCifsAgrupaciones'
import { getSedesAgrupaciones } from '@/services/configurations/rules/getSedesAgrupaciones'
import { getOrganismosAgrupaciones } from '@/services/configurations/rules/getOrganismosAgrupaciones'
import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'

import { getOrganismosAll } from '@/services/configurations/getOrganismosAll'
import { TIPOS_ESTADO_DESCARGA } from '@/config/tipos-estado-descarga'
import { TIPOS_MOMENTO_APLICACION_REGLAS } from '@/config/tipos-momento-aplicacion-reglas'

function checkValidPrioridad (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 1 && value <= 1000) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'rule-detail',
  components: {
    DetailLayout,
    AccessibleElSelect
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: 'DETALLE DE REGLA DE REPARTO',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/rules'
      },
      loadingSetRule: false,
      tiposEstadoDescarga: TIPOS_ESTADO_DESCARGA,
      tiposMomentoAplicacionReglas: TIPOS_MOMENTO_APLICACION_REGLAS,
      firstLoad: true,
      tooltipPrioridad: this.$i18n.t('tooltip.prioridad'),
      numMaxCondiciones: 10,
      numMaxValores: 10,
      dataMetadatosCondiciones: [],
      listMetadatasClient: [],
      listaCifs: [],
      listaGroups: [],
      listaSedes: [],
      listaAgrupOrganismos: [],
      listaValoresTexto: [],
      tiposNotification: TIPOS_NEO,
      estadosNotification: TIPOS_ESTADO_DESCARGA.filter(x => x.id ===2 || x.id === 13),
      // Organismos preseleccionados 
      organismosAux: [],
      organismos: [],
      loadingOrganismos: false,
      form: this.getDefaultForm(),
      // tiposCampo: TIPOS_CAMPO,
      // tiposCondicion: TIPOS_CONDICION,
      clientes: [],
      contentTooltipMetadatos: 'AVISO IMPORTANTE: Algunos metadatos adicionales de los indicados, los ofrece solamente un organismo o sede, por lo que si no está seguro de que la regla creada contemplará al organismo que le interese, busque otro metadato que le ofrezca esta garantía. Contacte con soporte@zerocoma.com para ampliar información de configuración.',
      contentTooltipValor: 'En caso de seleccionar valores múltiples se aplicarán como un "OR" dentro de la condición',
      contentTooltipValorRegex: 'Las expresiones regulares son patrones utilizados para encontrar una determinada combinación de caracteres dentro de una cadena de texto. Para generarla y probarla puede ir a https://regexr.com/ o pedir ayuda a ChatGPT',
      contentTooltipMetadataRegex: 'Metadato donde se guardará el valor encontrado por la expresión regular. Seleccione de forma opcional un metadato existente o escriba el nombre de uno nuevo y selecciónelo',
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      updateRules: {
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        prioridad: [
          { required: false, validator: this.isPriorityValid, trigger: 'blur' }
        ],
        MomentoAplicacion: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
      newRules: {
        clienteId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        prioridad: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isPriorityValid, trigger: 'blur' }
        ],
        MomentoAplicacion: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
      generalRules: {
        general: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        generalOptional: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
      },
    }
  },
  computed: {
    valuesForMomentoAplicacionReglasForAccessibleSelect: function () {
      return this.tiposMomentoAplicacionReglas.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    hasModuleAsistenciaIA () {
      return this.$store.getters['auth/hasModuleAsistenciaIA'] 
    },
    empresaFilter () {
      return this.isCreate ? this.$store.getters['rules/getMasterFilters']?.empresa?.value || null : null
    },
    tiposEstadoDescargaRule () {
      let estados = []
      if (!this.form.DescargarAutomaticamente) {
        estados = this.tiposEstadoDescarga
        if (this.form.MomentoAplicacion === 2) {
          estados = estados.filter(x => x.SalidaRegla === 'Descarga')
          // Controlamos los estados relacionados a módulos
          if (!this.hasModuleFlujoAceptacion) {
            estados = estados.filter(x => x.Modulo !== 28)
          } 
        } else if (this.form.MomentoAplicacion === 1) {
          estados = estados.filter(x => x.SalidaRegla === 'Vigilancia')
        } else {
          estados = []
        }
      }
      return estados
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({ id: cliente.IdEmpresa, value: cliente.IdEmpresa, name: cliente.Nombre }))
    },
    tiposEstadoDescargaForAccessibleSelect () {
      return this.tiposEstadoDescargaRule.map(estado => ({ id: estado.id, value: estado.id, name: estado.Nombre }))
    },
    dataMetadatosCondicionesForAccessibleSelect () {
      return this.dataMetadatosCondiciones.map(group => ({
        label: group.label,
        options: group.options.map(item => ({
          id: item.Descripcion,
          value: item.Descripcion,
          name: this.getDescriptionFromMetadato(item.Descripcion),
          disabled: this.checkDisabledMetadata(item, group)
        }))
      }))
    },
    listMetadatasClientForAccessibleSelect () {
      return this.listMetadatasClient.map(item => ({ 
        id: item.value, 
        value: item.value, 
        name: item.label 
      }))
    },
    estadosNotificationForAccessibleSelect () {
      return this.estadosNotification.map(estado => ({ 
        id: estado.Nombre, 
        value: estado.Nombre, 
        name: estado.Nombre 
      }))
    },
    tiposNotificationForAccessibleSelect () {
      return this.tiposNotification.map(tipo => ({ 
        id: tipo.Nombre, 
        value: tipo.Nombre, 
        name: tipo.Nombre 
      }))
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasModuleAsignacionMetadatosAEAT () {
      return this.$store.getters['auth/hasModuleAsignacionMetadatosAEAT']
    },
    hasModuleAsignacionSedeOrganismoCIF () {
      return this.$store.getters['auth/hasModuleAsignacionSedeOrganismoCIF']
    },
    hasModuleAsignacionContenido () {
      return this.$store.getters['auth/hasModuleAsignacionContenido']
    },
    hasModuleAsignacionAsunto () {
      return this.$store.getters['auth/hasModuleAsignacionAsunto']
    },
    hasModuleFlujoAceptacion () {
      return this.$store.getters['auth/hasModuleFlujoAceptacion']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.clienteId': function (value, oldValue) {
      this.onChangeClient()
    },
    'form.MomentoAplicacion': function (value, oldValue) {
      this.onChangeMomentoAplicacion()
    }, 
  },
  beforeDestroy () {
    this.cancelToken.cancel()
  },
  created: async function () {
    this.cancelToken = axios.CancelToken.source() 
    const breadcrumbs = []

    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
      if (this.isCreate) this.preSelectClient(this.form, 'clienteId')
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }
    breadcrumbs.push({ path: 'configurations/rules', name: this.$i18n.t('app.rules') })

    if (!this.isCreate || this.role === 'Administrador') await this.initialiceSelects()
    // if (this.role !== 'SuperAdministrador') await this.initialiceSelects()

    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    } else {
      breadcrumbs.push({
        path: '',
        name: this.$i18n.t('configurations.new_rule')
      })
      this.addCondition()
    }
    this.header.breadcrumb = breadcrumbs

    if (!this.isCreate || this.role === 'Administrador') await this.initialiceOrganismos()
    // if (this.role !== 'SuperAdministrador') await this.initialiceOrganismos()

    this.firstLoad = false
  },
  mounted () {
    this.resetControlFormChanges()
  },
  methods: {
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    getDescriptionFromMetadato (metadato) {
      return metadato === 'Fecha de Descarga' && this.form.MomentoAplicacion === 1 ? 'Fecha de Descarga externa' : metadato
    },
    checkDisabledMetadata (item, group) {
      if (group.label === 'Metadatos') {
        if (item.Descripcion === 'Comentarios') {
          if (this.form.MomentoAplicacion !== 2) {
            return true
          }
        }
        if (item.Descripcion === 'Estado de Notificación') {
          if (this.form.MomentoAplicacion !== 2) {
            return true
          }
        }
        if (item.Descripcion === 'Contenido') {
          if ((this.form.MomentoAplicacion !== 2) ||
            !this.hasModuleAsignacionContenido) {
            return true
          }
        }
        if (item.Descripcion === 'Asunto') {
          if (!this.hasModuleAsignacionAsunto) {
            return true
          }
        }
        
        // Control solo 1 de 3 Metadatos sin modulo correspondiente
        if (!this.hasModuleAsignacionSedeOrganismoCIF) {
          if (item.Descripcion === 'Sede' || 
            item.Descripcion === 'CIF Notificado' ||
            item.Descripcion === 'CIF Titular' ||
            item.Descripcion === 'Organismo') {
            return this.isUsedSedeOrganismoCIFMetadata()
          }
        }
      }

      if (group.label === 'Metadatos Adicionales') {
        if (item.Descripcion.startsWith('AEAT_')) {
          if ((this.form.MomentoAplicacion !== 2) || 
            !this.hasModuleAsignacionMetadatosAEAT) {
            return true
          }
        }
      }

      return false
    },
    isUsedSedeOrganismoCIFMetadata () {
      return this.form.condiciones.filter(x => x.campo === 'Sede' ||
        x.campo === 'CIF Notificado' ||
        x.campo === 'CIF Titular' ||
        x.campo === 'Organismo')
        .length > 0
    },
    onChangeClient: async function () {
      if (!this.firstLoad) {
        if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        // Get datos estaticos
          this.initialiceSelects()
          this.initialiceOrganismos()
        }
      }
    },
    onChangeMomentoAplicacion () {
      if (!this.loadingSetRule) {
        console.log('reset')
        this.form.estadoDestino = null
      }
    },
    isPriorityValid: function (rule, value, callback) {
      if (!value) {
        this.doAriaLiveAndReturnCallback(i18n.t('app.fill_data'), callback)
      } else if (!checkValidPrioridad(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.rules.priority'), callback)
      } else {
        callback()
      }
    },
    onChangeMetadato (index) {
      this.form.condiciones[index].tipoCondicion = null
      this.form.condiciones[index].valores = ['']
    },
    onChangeTipoCondicion (index) {
      this.form.condiciones[index].valores = ['']
    },
    initialiceSelects: async function () {
      this.$store.commit('setIsLoading', true)

      this.dataMetadatosCondiciones = []
      const respuestaMetadatos = await getMetadatosCondiciones({ idRegla: this.id })
      this.dataMetadatosCondiciones.push({
        label: 'Metadatos',
        options: respuestaMetadatos.Metadatos
      })
      this.dataMetadatosCondiciones.push({
        label: 'Metadatos Adicionales',
        options: respuestaMetadatos.MetadatosAdicionales
      })

      this.listaCifs = []
      const respuestaCifs = await getCifsAgrupaciones(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listaCifs.push({
        label: 'Agrupaciones',
        options: respuestaCifs.Agrupaciones ? respuestaCifs.Agrupaciones.map(x => ({
          valor: x.id,
          label: x.valor,
          id: x.id,
          esAgrupacion: true,
        })) : []
      })
      this.listaCifs.push({
        label: 'CIF',
        options: respuestaCifs.Entidades ? respuestaCifs.Entidades.map(x => ({
          valor: x.valor,
          label: x.valor + ' - ' + x.nombre,
          id: x.valor,
          esAgrupacion: false,
        })) : []
      })
      this.listaCifs.push({
        label: 'Valores',
        options: []
      })

      this.listaGroups = []
      const respuestaGrupos = await getGroupsSimple(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listaGroups = respuestaGrupos?.Respuesta?.filter(x => x.idTipo !== 3).map(x => ({
        id: x.IdGrupo,
        value: x.IdGrupo,
        Nombre: x.Nombre,
      }))


      this.listaSedes = []
      const respuestaSedes = await getSedesAgrupaciones(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listaSedes.push({
        label: 'Agrupaciones',
        options: respuestaSedes.Agrupaciones ? respuestaSedes.Agrupaciones.map(x => ({
          valor: x.id,
          label: x.valor,
          id: x.id,
          esAgrupacion: true,
        })) : []
      })
      this.listaSedes.push({
        label: 'Sedes',
        options: respuestaSedes.Entidades ? respuestaSedes.Entidades.map(x => ({
          valor: x.valor,
          label: x.nombre,
          id: x.valor,
          esAgrupacion: false,
        })) : []
      })
      this.listaValoresTexto = []
      const respuestaValoresTexto = await getValoresTextoAgrupaciones(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listaValoresTexto.push({
        label: 'Agrupaciones',
        options: respuestaValoresTexto.Agrupaciones ? respuestaValoresTexto.Agrupaciones.map(x => ({
          valor: x.id,
          label: x.valor,
          id: x.id,
          esAgrupacion: true,
        })) : []
      })
      const respuestaMetadataClient = await getListMetadatas(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.listMetadatasClient = respuestaMetadataClient.Respuesta ? respuestaMetadataClient.Respuesta.map(x => ({ value: x.Campo, label: x.Campo })) : []
      this.$store.commit('setIsLoading', false)
    },
    getListaCondicionesForAccessibleSelect (metadatoDescripcion) {
      const condiciones = this.getListaCondiciones(metadatoDescripcion)
      return condiciones.map(c => ({ 
        id: c.idTipoCondicion, 
        value: c.idTipoCondicion, 
        name: c.Descripcion 
      }))
    },
    getListaCondiciones (metadatoDescripcion) {
      if (this.dataMetadatosCondiciones[0] && this.dataMetadatosCondiciones[0].options
        .filter(x => x.Descripcion === metadatoDescripcion).length > 0) {
        return this.dataMetadatosCondiciones[0].options
          .filter(x => x.Descripcion === metadatoDescripcion)[0].TiposCondiciones
      }
      if (this.dataMetadatosCondiciones[1] && this.dataMetadatosCondiciones[1].options
        .filter(x => x.Descripcion === metadatoDescripcion).length > 0) {
        return this.dataMetadatosCondiciones[1].options
          .filter(x => x.Descripcion === metadatoDescripcion)[0].TiposCondiciones
      }
      return []
    },
    getTipoDato (metadatoDescripcion) {
      if (this.dataMetadatosCondiciones[0] && this.dataMetadatosCondiciones[0].options
        .filter(x => x.Descripcion === metadatoDescripcion).length > 0) {
        return this.dataMetadatosCondiciones[0].options
          .filter(x => x.Descripcion === metadatoDescripcion)[0].idTipoDato
      }
      if (this.dataMetadatosCondiciones[1] && this.dataMetadatosCondiciones[1].options
        .filter(x => x.Descripcion === metadatoDescripcion).length > 0) {
        return this.dataMetadatosCondiciones[1].options
          .filter(x => x.Descripcion === metadatoDescripcion)[0].idTipoDato
      }
      return -1
    },
    getListaSelect (metadatoDescripcion, esDistintoDe = false) {
      if (metadatoDescripcion === 'CIF Notificado' || metadatoDescripcion === 'CIF Titular') {
        if (esDistintoDe) {
          return this.listaCifs.filter(x => x.label !== 'Agrupaciones').map(group => ({
            label: group.label,
            options: group.options.map((item, index) => ({
              id: index,
              value: item,
              name: item.label
            }))
          })) 
        }
        return this.listaCifs.map(group => ({
          label: group.label,
          options: group.options.map((item, index) => ({
            id: index,
            value: item,
            name: item.label
          }))
        }))
      }
      if (metadatoDescripcion === 'Sede') {
        if (esDistintoDe) {
          return this.listaSedes.filter(x => x.label !== 'Agrupaciones').map(group => ({
            label: group.label,
            options: group.options.map((item, index) => ({
              id: index,
              value: item,
              name: item.label
            }))
          })) 
        }
        return this.listaSedes.map(group => ({
          label: group.label,
          options: group.options.map((item, index) => ({
            id: index,
            value: item,
            name: item.label
          }))
        }))
      }
      if (metadatoDescripcion === 'Organismo') {
        if (esDistintoDe) {
          return this.organismos.filter(x => x.label !== 'Agrupaciones').map(group => ({
            label: group.label,
            options: group.options.map((item, index) => ({
              id: index,
              value: item,
              name: item.label
            }))
          })) 
        }
        return this.organismos.map(group => ({
          label: group.label,
          options: group.options.map((item, index) => ({
            id: index,
            value: item,
            name: item.label
          }))
        }))
      }
      if (metadatoDescripcion === 'Grupo Propietario') {
        // TODO: No necesario
        return this.listaGroups.map(group => ({ 
          id: group.id, 
          value: group.value, 
          name: group.Nombre 
        }))
      }
      if (metadatoDescripcion === 'Tipo de Notificación') {
        return this.tiposNotification.map(tipo => ({ 
          id: tipo.id, 
          value: tipo.Nombre, 
          name: tipo.Nombre 
        }))
      }
      if (metadatoDescripcion === 'Estado de Notificación') {
        return this.estadosNotification.map(estado => ({ 
          id: estado.id, 
          value: estado.Nombre, 
          name: estado.Nombre 
        }))
      }
      if (metadatoDescripcion === 'Valores texto') {
        return this.listaValoresTexto.map(group => ({
          label: group.label,
          options: group.options.map((item, index) => ({
            id: index,
            value: item,
            name: item.label
          }))
        }))
      }
      return []
    },
    addCondition () {
      if (this.form.condiciones.length >= this.numMaxCondiciones) {
        this.doFeedback(`Ha llegado al número máximo de condiciones permitidos: ${this.numMaxCondiciones}`, 'warning')
        return
      }
      const newCondition = {
        campo: null,
        tipoCondicion: null,
        valores: [''],
      }
      this.form.condiciones.push(newCondition)
    },
    addValue (index) {
      if (this.form.condiciones[index].valores.length >= this.numMaxValores) {
        this.doFeedback(`Ha llegado al número máximo de valores permitidos: ${this.numMaxValores}`, 'warning')
        return
      }
      this.form.condiciones[index].valores.push('')
    },
    removeCondiction (index) {
      if (this.form.condiciones) this.form.condiciones.splice((index), 1)
    },
    removeValue (index, indexValue) {
      if (this.form.condiciones && this.form.condiciones[index].valores) {
        this.form.condiciones[index].valores.splice(indexValue, 1)
      }
    },
    getDefaultForm: function () {
      return {
        id: 0,
        name: '',
        prioridad: 100,
        EnUso: false,
        clienteId: null,
        DetenerEjecucion: true,
        EnviarIA: false,
        Activa: true,
        MomentoAplicacion: 1,
        DescargarAutomaticamente: false,
        estadoDestino: null,
        condiciones: []
      }
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName, continuar = false) {
      if (this.isCreate) {
        this.newRuleHandler(formName, continuar)
      } else {
        this.updateRuleHandler(formName)
      }
    },
    newRuleHandler: function (formName, continuar = false) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // TODO Dependiendo del tipo de grupo
          const params = {
            idEmpresa: this.form.clienteId,
            Nombre: this.form.name,
            Prioridad: this.form.prioridad,
            DetenerEjecucion: this.form.DetenerEjecucion,
            EnviarIA: this.form.EnviarIA,
            Activa: this.form.Activa,
            EnDescarga: this.form.MomentoAplicacion === 1 
              ? false : this.form.MomentoAplicacion === 2 
                ? true : null,
            DescargarAutomaticamente: this.form.MomentoAplicacion !== 2 ? this.form.DescargarAutomaticamente : false,
            idEstadoSalida: this.form.estadoDestino,
            Condiciones: this.formatCondicionesCreateUpdate(this.form.condiciones)
          }
          const response = await newRule(params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            this.resetControlFormChanges()
            if (continuar) {
              setTimeout(() => {
                this.$router.push({ name: 'configurations/rules/groups', params: { id: response.Respuesta } })  
              }, 250)
            } else {
              if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
                this.preSelectClient(this.form, 'clienteId')
              }
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    formatCondicionesCreateUpdate (condiciones) {
      const result = JSON.parse(JSON.stringify(condiciones))
      // console.log('result', result)
      // const result = condiciones.slice()
      result.forEach(x => {
        x.valores.forEach((y, index) => {
          if (typeof y !== 'object' &&
            !Array.isArray(y) &&
            y !== null) {
            if (this.isValidDateString(y)) {
              y = moment(y).format('YYYY-MM-DD HH:mm:ss')
            } 
            x.valores[index] = {
              esAgrupacion: false,
              valor: y,
            }
          } else {
            if (this.isValidDateString(y.valor)) {
              y.valor = moment(y.valor).format('YYYY-MM-DD HH:mm:ss')
            } 
          }
        })
      })
      return result
    },
    isValidDateString (dateString) {
      // console.log('dateString', dateString)
      if (!isNaN(dateString)) return false
      const newDate = dateString
      return moment(newDate, 'YYYY-MM-DDTHH:mm:ss', true).isValid() || moment(newDate, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]', true).isValid() 
    },
    formatCondicionesGet (condiciones) {
      // Object => JSON => object
      const result = JSON.parse(JSON.stringify(condiciones))
      // Formateamos valores
      result.forEach(x => {
        x.valores.forEach((y, index) => {
          if (typeof y === 'object' &&
            // !Array.isArray(y) &&
            y !== null) {
            // CIF y Sede para condiciones de selección (tenemos valores previamente cargados)
            if ((x.campo === 'CIF Notificado' || x.campo === 'CIF Titular' || x.campo === 'Sede') &&
              (x.tipoCondicion === 1 || x.tipoCondicion === 2)) {
              x.valores[index] = {
                esAgrupacion: y.esAgrupacion,
                valor: y.valor,
                id: y.valor,
              }
              if ((x.campo === 'CIF Notificado' || x.campo === 'CIF Titular') && !y.esAgrupacion) {
                if (!this.listaCifs[1].options.some(x => x.valor === y.valor)) {
                  this.listaCifs[2].options.push(
                    {
                      valor: y.valor,
                      label: y.valor,
                      id: y.valor,
                      esAgrupacion: false,
                    }
                  )
                }
              }
            // Grupos para condiciones de selección
            } else if (x.campo === 'Grupo Propietario' &&
              (x.tipoCondicion === 1 || x.tipoCondicion === 2)) {
              x.valores[index] = y.valor.idGrupo
            } else if (x.campo === 'Organismo' &&
              (x.tipoCondicion === 1 || x.tipoCondicion === 2)) {
              // Tenemos agrupaciones previamente cargadas, ponemos tal cual
              if (y.esAgrupacion) {
                x.valores[index] = {
                  esAgrupacion: y.esAgrupacion,
                  valor: y.valor,
                  id: y.valor,
                }
                // NO tenemos valores previamente cargados, nos vienen mas datos, añadimos para posterior formateo
              } else {
                x.valores[index] = {
                  esAgrupacion: y.esAgrupacion,
                  valor: y.valor.idOrganismo,
                  id: y.valor.idOrganismo,
                  Nombre: y.valor.Nombre,
                  CIF: y.valor.CIF,
                }
              }
            } else if (this.getTipoDato(x.campo) === 2 && x.tipoCondicion !== 2) {
              if (y.esAgrupacion) {
                x.valores[index] = {
                  esAgrupacion: y.esAgrupacion,
                  valor: y.valor,
                  id: y.valor,
                }
              } else {
                x.valores[index] = y.valor
              }
            } else {
              // Resto de casos (string, number, fecha) solo necesitamos valor
              x.valores[index] = y.valor
            }
          } else {
            if (this.isValidDateString(y)) {
              y = moment(y).format('YYYY-MM-DD HH:mm:ss')
            } 
          }
        })
      })
      return result
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateRuleHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // TODO Dependiendo del tipo de grupo
          const params = {
            idRegla: this.form.id,
            Nombre: this.form.name,
            Prioridad: this.form.prioridad,
            DetenerEjecucion: this.form.DetenerEjecucion,
            EnviarIA: this.form.EnviarIA,
            Activa: this.form.Activa,
            EnDescarga: this.form.MomentoAplicacion === 1 
              ? false : this.form.MomentoAplicacion === 2 
                ? true : null,
            DescargarAutomaticamente: this.form.MomentoAplicacion !== 2 ? this.form.DescargarAutomaticamente : false,
            idEstadoSalida: this.form.estadoDestino,
            Condiciones: this.formatCondicionesCreateUpdate(this.form.condiciones)
          }
          const response = await updateRule(params)
          if (response.blnError === false) {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.updateView()
            this.$store.commit('setAjaxRequestPending', false)
            this.resetControlFormChanges()
          } else {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/rules' })
    },
    downloadData: async function (id) {
      let regla = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idRegla: id
        }
        regla = await getRule(params, this.cancelToken)
        this.setRule(regla.Respuesta)
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Petición cancelada')
        } else {
          this.doFeedback()
          console.log(error)
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return regla
    },
    setRule: function (regla) {
      this.loadingSetRule = true
      this.form.id = regla.idRegla
      this.form.clienteId = regla.idEmpresa
      this.form.name = regla.Nombre
      this.form.prioridad = regla.Prioridad
      this.form.enUso = regla.EnUso
      this.form.DetenerEjecucion = regla.DetenerEjecucion
      this.form.EnviarIA = regla.EnviarIA
      this.form.Activa = regla.Activa
      this.form.MomentoAplicacion = regla.EnDescarga === true 
        ? 2 : regla.EnDescarga === false 
          ? 1 : 3
      this.form.DescargarAutomaticamente = regla.DescargarAutomaticamente
      this.form.estadoDestino = regla.idEstadoSalida
      this.form.condiciones = regla.Condiciones ? this.formatCondicionesGet(regla.Condiciones) : []
      this.setCheckOrganismosAux()
      this.resetControlFormChanges()
      setTimeout(() => {
        this.loadingSetRule = false
      }, 100)
    },
    setCheckOrganismosAux () {
      this.organismosAux = []
      this.form.condiciones
        .filter(x => x.campo === 'Organismo' && (x.tipoCondicion === 1 || x.tipoCondicion === 2))
        .forEach(x => {
          x.valores.forEach(y => {
            if (y.esAgrupacion === false) this.organismosAux.push(y)
          })
        })
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    },
    initialiceOrganismos: async function (byRemoteLoad = false) {
      if (byRemoteLoad) this.organismos = []
      const respuestaOrganismos = await getOrganismosAgrupaciones(this.isCreate ? { idCliente: this.form.clienteId } : { idRegla: this.id })
      this.organismos.push({
        label: 'Agrupaciones',
        options: respuestaOrganismos.Agrupaciones ? respuestaOrganismos.Agrupaciones.map(x => ({
          valor: x.id,
          label: x.valor,
          id: x.id,
          esAgrupacion: true,
        })) : []
      })
      this.organismos.push({
        label: 'Organismos',
        options: []
      })
      // Formeateamos organismos
      this.organismosAux.forEach(element => {
        if (element.esAgrupacion === false) {
          this.organismos[1].options.push(
            { 
              valor: element.valor,
              id: element.valor, 
              label: this.formatNombreOrg(element),
              esAgrupacion: false,
            }
          )
        }
      })
    },
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    remoteOrganismos: async function (query) {
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        await this.initialiceOrganismos(true)
        setTimeout(async () => {
          const organismos = await getOrganismosAll({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.organismos[1].options.push(
                { 
                  id: element.idOrganismo, 
                  valor: element.idOrganismo, 
                  label: this.formatNombreOrg(element),
                  esAgrupacion: false,
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      }
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
